// Ayuntamiento.jsx
import React from 'react';
import { Carousel } from 'react-bootstrap';
import './Ayuntamiento.css';
import imagen1 from '../Images/Menu.jpg';
import imagen2 from '../Images/Menu2.JPG';
import imagen3 from '../Images/Menu3.jpg';

const Ayuntamiento = () => {
  return (
    <div className="ayuntamiento-carousel">
      <Carousel indicators={false}>
        <Carousel.Item>
          <img
            className="d-block w-100 carousel-image"
            src={imagen1}
            alt="Primera imagen"
          />
          <Carousel.Caption className="custom-caption">
            <h3>¡Conoce Escalonilla!</h3>
            <a 
              href="/pueblo/datos-interes"
              className="custom-button"
              onClick={(e) => e.stopPropagation()}
            >
              Datos de Interés
            </a>
          </Carousel.Caption>
        </Carousel.Item>

        <Carousel.Item>
          <img
            className="d-block w-100 carousel-image"
            src={imagen2}
            alt="Segunda imagen"
          />
          <Carousel.Caption className="custom-caption">
            <h3>¡Conoce Escalonilla!</h3>
            <a
              href="/pueblo/datos-interes"
              className="custom-button"
              onClick={(e) => e.stopPropagation()}
            >
              Datos de Interés
            </a>
          </Carousel.Caption>
        </Carousel.Item>

        <Carousel.Item>
          <img
            className="d-block w-100 carousel-image"
            src={imagen3}
            alt="Tercera imagen"
          />
          <Carousel.Caption className="custom-caption">
            <h3>¡Conoce Escalonilla!</h3>
            <a
              href="/pueblo/datos-interes"
              className="custom-button"
              onClick={(e) => e.stopPropagation()}
            >
              Datos de Interés
            </a>
          </Carousel.Caption>
        </Carousel.Item>
      </Carousel>
    </div>
  );
};

export default Ayuntamiento;
